import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../WhatIfsSelector';

export const principalName = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return whatIfOptions.PrincipalName;
};
export const partnerName = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return whatIfOptions.SpouseName;
};
export const hasPartner = (state, props) => !!partnerName(state, props);

export const principalOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return (whatIfOptions.LifeExpectancyPrincipalOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};
export const partnerOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return (whatIfOptions.LifeExpectancySpouseOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};

export const principalLifeExpectancySelector = (state, props) =>
  whatIfInnerSelector(state, props).LifeExpectancyPrincipal;
export const partnerLifeExpectancySelector = (state, props) =>
  whatIfInnerSelector(state, props).LifeExpectancySpouse;
